"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHelmet = createHelmet;
exports.getCategoryDefault = void 0;

var _SeoManagerHelpers = require("./SeoManagerHelpers");

/*
 * CasaOldHelmetDataHelper:
 * USED ONLY FOR OLD SEO URL -- Will be deprecated with the full passage to the new url
 */
var HELMET_AGENCY_TYPE = 'HELMET_AGENCY_TYPE';
var HELMET_AGENCY_NOT_FOUND_TYPE = 'HELMET_AGENCY_NOT_FOUND_TYPE';
var HELMET_SRP_TYPE = 'HELMET_SRP_TYPE';
var HELMET_SRP_NO_LOC_TYPE = 'HELMET_SRP_NO_LOC_TYPE';
var HELMET_SRP_NO_PROP_TYPE = 'HELMET_SRP_NO_PROP_TYPE';
var HELMET_SRP_NO_PROP_NO_LOC_TYPE = 'HELMET_SRP_NO_PROP_NO_LOC_TYPE';
var HELMET_TYPE_H1 = 'H1';

var capitalize = function capitalize(input) {
  if (!input) return '';
  return "".concat(input.charAt(0).toUpperCase()).concat(input.slice(1));
};

var integerWithEuropeThousandSeparator = function integerWithEuropeThousandSeparator(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

var getPropertyTypes = function getPropertyTypes(propertyTypes) {
  if (!Array.isArray(propertyTypes)) {
    propertyTypes = [propertyTypes];
  }

  return Array.from(propertyTypes, function (x) {
    return _SeoManagerHelpers.PROPERTY_TYPES_PLURAL[x.slug];
  }).join(', ') || 'annunci';
};

var TR_ENCODED = {
  it: {
    buy: 'vendita',
    rent: 'affitto',
    vendita: 'vendita',
    affitti: 'affitto',
    affitto: 'affitto',
    any: 'vendita e affitto',
    all: 'vendita e affitto'
  }
};

var getRoomsRange = function getRoomsRange(roomsRange) {
  var title;

  switch (roomsRange) {
    case '1':
      title = 'monolocali';
      break;

    case '2':
      title = 'bilocali';
      break;

    case '3':
      title = 'trilocali';
      break;

    case '4':
      title = 'quadrilocali';
      break;

    default:
      title = "case";
  }

  return title;
};

var agentObject = function agentObject(agentCategory) {
  switch (agentCategory) {
    case 'agency':
      return 'agenzie';

    case 'private':
      return 'privati';

    default:
      return 'costruttori';
  }
};

var getAgentCategory = function getAgentCategory(agentCategory) {
  var title;

  if (agentCategory.length > 1) {
    var agents = '';

    for (var i = 0; i < agentCategory.length; i += 1) {
      agents += i === 0 ? agentObject(agentCategory[i]) : ", ".concat(agentObject(agentCategory[i]));
    }

    title = "- Annunci immobiliari da ".concat(agents, " - Casa.it");
  } else {
    switch (agentCategory[0]) {
      case 'agency':
        title = " - Annunci immobiliari da ".concat(agentObject(agentCategory[0]), " - Casa.it");
        break;

      case 'private':
        title = " - Annunci immobiliari da ".concat(agentObject(agentCategory[0]), " - Casa.it");
        break;

      default:
        // costruttori
        title = " - Annunci immobiliari da ".concat(agentObject(agentCategory[0]), " - Casa.it");
    }
  }

  return title;
};

var getCategoryDefault = function getCategoryDefault(category) {
  var defaultType;

  switch (category) {
    case 'vacanze':
    case 'case-vacanza':
      defaultType = 'case vacanza';
      break;

    case 'commerciale':
      defaultType = 'immobili commerciali';
      break;

    case 'cantine-solai':
      defaultType = 'cantine, solai';
      break;

    case 'garage-posti-auto':
      defaultType = 'garage, posti auto';
      break;

    case 'stanze':
      defaultType = 'stanze';
      break;

    case 'terreni':
      defaultType = 'terreni';
      break;

    default:
      defaultType = 'case';
  }

  return defaultType;
};

exports.getCategoryDefault = getCategoryDefault;

var getAgentForDesc = function getAgentForDesc(agentCategory) {
  var agent;

  if (agentCategory.length > 1) {
    var agents = '';

    for (var i = 0; i < agentCategory.length; i += 1) {
      if (i === 0) {
        agents += agentObject(agentCategory[i]);
      } else if (i === agentCategory.length - 1) {
        agents += " e ".concat(agentObject(agentCategory[i]));
      } else {
        agents += ", ".concat(agentObject(agentCategory[i]));
      }
    }

    agent = " da ".concat(agents, " ");
  } else {
    agent = " da ".concat(agentObject(agentCategory[0]), " ");
  }

  return agent;
};

var getTotalListings = function getTotalListings(count) {
  return "tutti ".concat(count === 0 ? 'gli annunci' : 'i/gli').trim();
};

var getLocalities = function getLocalities(locations, domain, position) {
  var withZone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var zonestitle = '';
  var otherstitle = '';
  var zones = locations.filter(function (el) {
    return el.type === 'zone';
  });
  var others = locations.filter(function (el) {
    return el.type !== 'zone';
  });

  if (zones.length > 0) {
    var parents = [];
    var parentsObj = {};

    for (var i = 0; i < zones.length; i += 1) {
      parents.push(zones[i].levels.L9);
    }

    for (var n = 0; n < parents.length; n += 1) {
      var siblings = [];

      for (var _i = 0; _i < zones.length; _i += 1) {
        if (zones[_i].levels.L9 === parents[n]) {
          siblings.push(zones[_i]);
        }
      }

      parentsObj[parents[n]] = siblings;
    }

    if (Object.keys(parentsObj).length > 0) {
      for (var _i2 = 0; _i2 < Object.keys(parentsObj).length; _i2 += 1) {
        var cityTitle = '';

        var city = Object.keys(parentsObj)[_i2];

        if (parentsObj[Object.keys(parentsObj)[_i2]].length === 1) {
          var zSingleSep = _i2 === Object.keys(parentsObj).length - 1 ? ' e ' : ', ';

          if (_i2 === 0) {
            zSingleSep = '';
          }

          zonestitle += withZone ? "".concat(zSingleSep, "a ").concat(city, " in zona ").concat(parentsObj[Object.keys(parentsObj)[_i2]][0].levels.L10) : "".concat(zSingleSep, "a ").concat(city);
        } else {
          for (var _n = 0; _n < parentsObj[Object.keys(parentsObj)[_i2]].length; _n += 1) {
            var area = parentsObj[Object.keys(parentsObj)[_i2]][_n];

            var zSep = _i2 === parentsObj[Object.keys(parentsObj)[_i2]].length - 1 ? ' e' : ',';
            cityTitle += _n === 0 ? "".concat(area.levels.L10.replace(/\//g, ',')) : "".concat(zSep, " ").concat(area.levels.L10);
          }

          var zMultiSep = _i2 === Object.keys(parentsObj).length - 1 ? ' e ' : ', ';

          if (_i2 === 0) {
            zMultiSep = '';
          }

          if (position === 'title') {
            zonestitle += withZone ? "".concat(zMultiSep, "a ").concat(city, " nelle zone: ").concat(cityTitle) : "".concat(zMultiSep, "a ").concat(city);
          } else {
            zonestitle += withZone ? "".concat(zMultiSep, "a ").concat(city, " nelle zone: ").concat(cityTitle) : "".concat(zMultiSep, "a ").concat(city);
          }
        }
      }
    }
  }

  if (others.length > 0) {
    for (var _i3 = 0; _i3 < others.length; _i3 += 1) {
      var locObject = locationObject(others[_i3], domain);
      var oSep = _i3 === others.length - 1 ? ' e' : ',';
      otherstitle += _i3 === 0 && zonestitle === '' ? "".concat(locObject.preposition, " ").concat(locObject.location) : "".concat(oSep, " ").concat(locObject.preposition, " ").concat(locObject.location);
    }
  }

  return " ".concat(zonestitle).concat(otherstitle);
};

var locationObject = function locationObject(location, domain) {
  if (!location.levels) {
    location.levels = location.slugs || {};
  }

  ;

  switch (location.type) {
    case 'region':
      return {
        preposition: 'in',
        location: location.levels.L4
      };

    case 'street':
      return {
        preposition: 'in',
        location: "".concat(location.levels.L10, ", ").concat(location.levels.L9)
      };

    case 'zone':
      return domain === 'attico' ? {
        preposition: 'a',
        location: location.levels.L9
      } : {
        preposition: 'in',
        location: "".concat(location.levels.L10.replace(/\//g, ','), " (").concat(location.levels.L9, ")")
      };

    case 'province':
      return {
        preposition: 'in',
        location: "provincia di ".concat(location.levels.L6)
      };

    case 'region':
      return {
        preposition: 'in',
        location: location.levels.L4
      };

    case 'postalcode':
      return {
        preposition: 'al',
        location: location.postalcode
      };

    case 'freetext':
      return {
        preposition: 'a',
        location: location.name
      };

    default:
      return {
        preposition: 'a',
        location: location.levels.L9
      };
  }
};

var analyzeLocalities = function analyzeLocalities(locations) {
  var flag = false;
  var cities = locations.filter(function (el) {
    return el.type === 'town';
  });
  var zones = locations.filter(function (el) {
    return el.type === 'zone';
  });

  if (cities.length > 0 || zones.length === 1) {
    flag = true;
  }

  return flag;
};

var createTitle = function createTitle(domain, helmetType, data) {
  var agencyDetail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var withZone = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  // console.log('\n******** OLD *** helmetType ********', helmetType)
  var surrounding = '';

  if (data.filters && (data.filters.surroundingSuburbs === true || data.filters.surroundingSuburbs === 'true')) {
    surrounding = ' e dintorni';
  }

  var channel = data.channel,
      _data$filters = data.filters,
      category = _data$filters.category,
      propertyTypes = _data$filters.propertyTypes,
      roomsRange = _data$filters.roomsRange,
      agentCategory = _data$filters.agentCategory;
  var descTr = channel ? " in ".concat(channel) : '';
  var propertyTypesDesc = propertyTypes ? getPropertyTypes(propertyTypes) : '';
  var isPType = propertyTypesDesc && propertyTypesDesc.trim().length > 0 && propertyTypesDesc.trim().toLocaleLowerCase() !== 'annunci';
  var rooms = roomsRange.minimum === 'any' || roomsRange.maximum === 'any' ? ' ' : roomsRange.minimum === roomsRange.maximum ? "".concat(getRoomsRange(roomsRange.minimum), " ") : ' ';
  var isRooms = rooms && rooms.trim().length > 0 && rooms.trim().toLocaleLowerCase() !== 'case';
  var prefixDesc = "".concat(propertyTypesDesc, " ").concat(isPType ? "".concat(isRooms ? rooms : '') : rooms);
  var fd = data.features ? data.features.map(function (f) {
    return FEATURES_LABEL[f];
  }).join(', ') : '';
  var ncommas = fd.split(/,/).length;
  var pos = fd.lastIndexOf(',');
  var areEquals = roomsRange.minimum !== 'any' && roomsRange.minimum === roomsRange.maximum;
  var pageDescr = data.page > 1 ? " - pagina ".concat(data.page) : '';
  var SEOTitleEnd = agentCategory === 'all' ? ' - Casa.it' : getAgentCategory(agentCategory);

  switch (helmetType) {
    case HELMET_AGENCY_TYPE:
      return "Agenzia".concat(agencyDetail.name && agencyDetail.name !== '' ? " ".concat(agencyDetail.name) : '', ", annunci immobiliari vendita a ").concat(agencyDetail.address.suburb, " - ").concat(domain === 'attico' ? 'Attico.it' : '- Casa.it');

    case HELMET_AGENCY_NOT_FOUND_TYPE:
      return "Agenzia non trovata - ".concat(domain === 'attico' ? 'Attico.it' : 'Casa.it');

    case HELMET_SRP_TYPE:
      {
        if (domain === 'attico') {
          return "".concat(getPropertyTypes(propertyTypes)).concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone), " - Attico.it");
        } else {
          switch (category) {
            case 'commerciale':
              return "".concat(getPropertyTypes(propertyTypes)).concat(!areEquals ? ' ' : " con ".concat(roomsRange.minimum, " locali ")).concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(pageDescr).concat(SEOTitleEnd);

            case 'vacanze':
              return "".concat(prefixDesc, "per vacanze").concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(SEOTitleEnd);

            default:
              return "".concat(prefixDesc).concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(SEOTitleEnd);
          }
        }
      }

    case HELMET_SRP_NO_LOC_TYPE:
      {
        if (domain === 'attico') {
          return "".concat(getPropertyTypes(propertyTypes)).concat(descTr, " - Attico.it");
        } else {
          switch (category) {
            case 'commerciale':
              return "".concat(getPropertyTypes(propertyTypes)).concat(!areEquals ? ' ' : " ".concat(roomsRange.minimum, " locali ")).concat(descTr, "tra gli immobili commerciali").concat(pageDescr).concat(SEOTitleEnd);

            case 'vacanze':
              return "".concat(prefixDesc, "per vacanze").concat(descTr).concat(pageDescr).concat(SEOTitleEnd);

            case 'terreni':
            case 'cantine-solai':
            case 'garage-posti-auto':
            case 'stanze':
              return "".concat(prefixDesc).concat(descTr).concat(pageDescr).concat(SEOTitleEnd);

            default:
              return "".concat(prefixDesc).concat(descTr).concat(pageDescr).concat(SEOTitleEnd);
          }
        }
      }

    case HELMET_SRP_NO_PROP_TYPE:
      {
        if (domain === 'attico') {
          switch (category) {
            case 'commerciale':
              return "Commerciale/Industriale".concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone), " - Attico.it");

            case 'vacanze':
              return "Case vacanza".concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone), " - Attico.it");

            default:
              return "Case".concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone), " - Attico.it");
          }
        } else {
          var SEOTitleStart;

          switch (category) {
            case 'commerciale':
              SEOTitleStart = "".concat(capitalize(getCategoryDefault(category))).concat(!areEquals ? ' ' : " con ".concat(roomsRange.minimum, " local").concat(parseInt(roomsRange.minimum, 10) === 1 ? 'e' : 'i')).concat(descTr);
              return "".concat(SEOTitleStart).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(SEOTitleEnd);

            case 'vacanze':
              SEOTitleStart = "".concat(capitalize(getCategoryDefault(category))).concat(descTr);
              return "".concat(SEOTitleStart).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(SEOTitleEnd);

            case 'terreni':
            case 'cantine-solai':
            case 'garage-posti-auto':
            case 'stanze':
              SEOTitleStart = "".concat(capitalize(getCategoryDefault(category))).concat(descTr);
              return "".concat(SEOTitleStart).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(SEOTitleEnd);

            default:
              SEOTitleStart = !areEquals ? "".concat(capitalize(getCategoryDefault(category))).concat(descTr) : "".concat(capitalize(getRoomsRange(roomsRange.minimum))).concat(descTr);
              return "".concat(SEOTitleStart).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(surrounding).concat(pageDescr).concat(SEOTitleEnd);
          }
        }
      }

    case HELMET_SRP_NO_PROP_NO_LOC_TYPE:
      {
        if (domain === 'attico') {
          switch (category) {
            case 'commerciale':
              return "Commerciale/Industriale".concat(descTr, " - Attico.it");

            case 'vacanze':
              return "Case vacanza".concat(descTr, " - Attico.it");

            default:
              return "Case".concat(descTr, " - Attico.it");
          }
        } else {
          var _SEOTitleStart;

          switch (category) {
            case 'commerciale':
              _SEOTitleStart = !areEquals ? 'Immobili commerciali' : "Immobili commerciali con ".concat(roomsRange.minimum, " locali");
              return "".concat(_SEOTitleStart).concat(descTr).concat(pageDescr).concat(SEOTitleEnd);

            case 'vacanze':
              _SEOTitleStart = !areEquals ? 'Case vacanze' : roomsRange.minimum[0] === '1' ? 'Case vacanze con 1 locale' : "".concat(capitalize(getRoomsRange(roomsRange.minimum)), " per vacanze");
              return "".concat(_SEOTitleStart).concat(descTr).concat(pageDescr).concat(SEOTitleEnd);

            case 'terreni':
            case 'cantine-solai':
            case 'garage-posti-auto':
            case 'stanze':
              _SEOTitleStart = "".concat(capitalize(getCategoryDefault(category))).concat(descTr);
              return "".concat(_SEOTitleStart).concat(descTr).concat(pageDescr).concat(SEOTitleEnd);

            default:
              _SEOTitleStart = !areEquals ? "".concat(capitalize(getCategoryDefault(category))).concat(descTr) : "".concat(capitalize(getRoomsRange(roomsRange.minimum))).concat(descTr);
              return "".concat(_SEOTitleStart).concat(pageDescr).concat(SEOTitleEnd);
          }
        }
      }
  }
};

var createH1 = function createH1(domain, helmetType, data) {
  var agencyDetail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var withZone = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var descTr = data.channel ? " in ".concat(data.channel) : '';

  switch (helmetType) {
    case HELMET_AGENCY_TYPE:
      return "Agenzia".concat(agencyDetail.name && agencyDetail.name !== '' ? " ".concat(agencyDetail.name) : '', ", annunci immobiliari vendita a ").concat(agencyDetail.address.suburb);

    case HELMET_AGENCY_NOT_FOUND_TYPE:
      return 'Agenzia non trovata';

    case HELMET_SRP_TYPE:
      {
        var _data$filters2 = data.filters,
            category = _data$filters2.category,
            propertyTypes = _data$filters2.propertyTypes,
            roomsRange = _data$filters2.roomsRange,
            agentCategory = _data$filters2.agentCategory;
        var rooms = roomsRange.minimum === 'any' ? ' ' : " ".concat(getRoomsRange(roomsRange.minimum), " ");
        var SEOTitleEnd = agentCategory === 'all' ? '' : getAgentCategory(agentCategory);

        if (domain === 'attico') {
          return "".concat(getPropertyTypes(propertyTypes)).concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone));
        } else {
          switch (category) {
            case 'commerciale':
              return "".concat(getPropertyTypes(propertyTypes)).concat(roomsRange.minimum === 'any' ? ' ' : " ".concat(roomsRange.minimum, " locali ")).concat(descTr, "tra gli immobili commerciali ").concat(getLocalities(data.locations, domain, 'title', withZone)).concat(SEOTitleEnd);

            case 'vacanze':
              return "".concat(getPropertyTypes(propertyTypes)).concat(rooms, "per vacanze").concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(SEOTitleEnd);

            default:
              return "".concat(getPropertyTypes(propertyTypes)).concat(rooms).concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone)).concat(SEOTitleEnd);
          }
        }
      }

    case HELMET_SRP_NO_LOC_TYPE:
      {
        var _data$filters3 = data.filters,
            _category = _data$filters3.category,
            _propertyTypes = _data$filters3.propertyTypes,
            _roomsRange = _data$filters3.roomsRange,
            _agentCategory = _data$filters3.agentCategory;

        var _rooms = _roomsRange.minimum === 'any' ? ' ' : " ".concat(getRoomsRange(_roomsRange.minimum), " ");

        var _SEOTitleEnd = _agentCategory === 'all' ? '' : getAgentCategory(_agentCategory);

        if (domain === 'attico') {
          return "".concat(getPropertyTypes(_propertyTypes)).concat(descTr);
        } else {
          switch (_category) {
            case 'commerciale':
              return "".concat(getPropertyTypes(_propertyTypes)).concat(_roomsRange.minimum === 'any' ? ' ' : " ".concat(_roomsRange.minimum, " locali ")).concat(descTr, "tra gli immobili commerciali").concat(_SEOTitleEnd);

            case 'vacanze':
              return "".concat(getPropertyTypes(_propertyTypes)).concat(_rooms, "per vacanze").concat(descTr).concat(_SEOTitleEnd);

            default:
              return "".concat(getPropertyTypes(_propertyTypes)).concat(_rooms).concat(descTr).concat(_SEOTitleEnd);
          }
        }
      }

    case HELMET_SRP_NO_PROP_TYPE:
      {
        var channel = data.channel,
            _data$filters4 = data.filters,
            _category2 = _data$filters4.category,
            _roomsRange2 = _data$filters4.roomsRange,
            _agentCategory2 = _data$filters4.agentCategory;

        var _SEOTitleEnd2 = _agentCategory2 === 'all' ? '' : getAgentCategory(_agentCategory2);

        if (domain === 'attico') {
          switch (_category2) {
            case 'commerciale':
              return "Commerciale/Industriale".concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone));

            case 'vacanze':
              return "Case vacanza".concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone));

            default:
              return "Case".concat(descTr).concat(getLocalities(data.locations, domain, 'title', withZone));
          }
        } else {
          var SEOTitleStart;

          switch (_category2) {
            case 'commerciale':
              SEOTitleStart = _roomsRange2.minimum === 'any' ? "".concat(capitalize(channel), " ").concat(getCategoryDefault(_category2)) : "".concat(capitalize(getCategoryDefault(_category2)), " ").concat(_roomsRange2.minimum, " locali").concat(descTr);
              return "".concat(SEOTitleStart, " ").concat(getLocalities(data.locations, domain, 'title', withZone)).concat(_SEOTitleEnd2);

            case 'vacanze':
              SEOTitleStart = _roomsRange2.minimum === 'any' ? "".concat(capitalize(channel), " ").concat(getCategoryDefault(_category2)) : "".concat(capitalize(getRoomsRange(_roomsRange2.minimum)), " vacanze").concat(descTr);
              return "".concat(SEOTitleStart, " ").concat(getLocalities(data.locations, domain, 'title', withZone)).concat(_SEOTitleEnd2);

            default:
              SEOTitleStart = _roomsRange2.minimum === 'any' ? "".concat(capitalize(channel), " ").concat(getCategoryDefault(_category2)) : "".concat(capitalize(getRoomsRange(_roomsRange2.minimum))).concat(descTr);
              return "".concat(SEOTitleStart, " ").concat(getLocalities(data.locations, domain, 'title', withZone)).concat(_SEOTitleEnd2);
          }
        }
      }

    case HELMET_SRP_NO_PROP_NO_LOC_TYPE:
      {
        var _data$filters5 = data.filters,
            _category3 = _data$filters5.category,
            _roomsRange3 = _data$filters5.roomsRange,
            _agentCategory3 = _data$filters5.agentCategory;

        var _SEOTitleEnd3 = _agentCategory3 === 'all' ? '' : getAgentCategory(_agentCategory3);

        if (domain === 'attico') {
          switch (_category3) {
            case 'commerciale':
              return "Commerciale/Industriale".concat(descTr);

            case 'vacanze':
              return "Case vacanza".concat(descTr);

            default:
              return "Case".concat(descTr);
          }
        } else {
          var _SEOTitleStart2;

          switch (_category3) {
            case 'commerciale':
              _SEOTitleStart2 = _roomsRange3.minimum === 'any' ? 'Immobili commerciali' : "Immobili commerciali con ".concat(_roomsRange3.minimum, " locali");
              return "".concat(_SEOTitleStart2).concat(descTr).concat(_SEOTitleEnd3);

            case 'vacanze':
              _SEOTitleStart2 = _roomsRange3.minimum === 'any' ? 'Case vacanze' : _roomsRange3.minimum[0] === '1' ? 'Case vacanze con 1 locale' : "".concat(capitalize(getRoomsRange(_roomsRange3.minimum)), " per vacanze");
              return "".concat(_SEOTitleStart2).concat(descTr).concat(_SEOTitleEnd3);

            default:
              _SEOTitleStart2 = _roomsRange3.minimum === 'any' ? 'Case' : capitalize(getRoomsRange(_roomsRange3.minimum));
              return "".concat(_SEOTitleStart2).concat(descTr).concat(_SEOTitleEnd3);
          }
        }
      }
  }
};

var createDescription = function createDescription(domain, helmetType, data) {
  var agencyDetail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var count = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var withZone = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var descTr = data.channel ? " in ".concat(data.channel) : '';
  var _data$filters6 = data.filters,
      propertyTypes = _data$filters6.propertyTypes,
      category = _data$filters6.category,
      roomsRange = _data$filters6.roomsRange,
      agentCategory = _data$filters6.agentCategory;
  var areEquals = roomsRange.minimum !== 'any' && roomsRange.minimum === roomsRange.maximum;

  switch (helmetType) {
    case HELMET_AGENCY_TYPE:
      return "Agenzia".concat(agencyDetail.name && agencyDetail.name !== '' ? " ".concat(agencyDetail.name) : '', " a ").concat(agencyDetail.address.suburb, ". Scopri tutti gli annunci di immobili in vendita dell&#039;agenzia ").concat(agencyDetail.name, ". e contatta il tuo agente di fiducia online su ").concat(domain === 'attico' ? 'Attico.it' : 'Casa.it', "!");

    case HELMET_AGENCY_NOT_FOUND_TYPE:
      return "Agenzia non trovata. Scopri tutti gli annunci di immobili in vendita delle agenzie e contatta il tuo agente di fiducia online su ".concat(domain === 'attico' ? 'Attico.it' : 'Casa.it', "!");

    case HELMET_SRP_TYPE:
      {
        if (domain === 'attico') {
          return "Tutti gli annunci di ".concat(getPropertyTypes(propertyTypes)).concat(descTr).concat(getLocalities(data.locations, domain, 'desc', withZone), ": la soluzione che stai cercando \xE8 su Attico.it!");
        } else {
          var rooms = !areEquals ? ' ' : category === 'commerciale' ? " con ".concat(roomsRange.minimum, " locali ") : " ".concat(getRoomsRange(roomsRange.minimum), " ");
          var sellerType = agentCategory === 'all' ? ' ' : getAgentForDesc(agentCategory);

          switch (category) {
            case 'commerciale':
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(getPropertyTypes(propertyTypes).toLowerCase()).concat(rooms).concat(descTr).concat(sellerType, "tra gli immobili commerciali ").concat(getLocalities(data.locations, domain, 'desc', withZone), " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

            case 'vacanze':
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(getPropertyTypes(propertyTypes).toLowerCase()).concat(rooms, "per vacanze").concat(descTr).concat(sellerType).concat(getLocalities(data.locations, domain, 'desc', withZone), " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

            default:
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(getPropertyTypes(propertyTypes).toLowerCase()).concat(rooms).concat(descTr).concat(sellerType).concat(getLocalities(data.locations, domain, 'desc', withZone), " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
          }
        }
      }

    case HELMET_SRP_NO_LOC_TYPE:
      {
        var _rooms2 = !areEquals ? ' ' : category === 'commerciale' ? " con ".concat(roomsRange.minimum, " locali ") : " ".concat(getRoomsRange(roomsRange.minimum), " ");

        var _sellerType = agentCategory === 'all' ? ' ' : getAgentForDesc(agentCategory);

        return domain === 'attico' ? "Tutti gli annunci di ".concat(getPropertyTypes(propertyTypes)).concat(descTr, ": la soluzione che stai cercando \xE8 su Attico.it!") : "".concat(getPropertyTypes(propertyTypes)).concat(_rooms2).concat(descTr).concat(_sellerType).concat(category === 'vacanze' ? ' per le vacanze' : '', ": cerca tra ").concat(getTotalListings(count), " annunci disponibili e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
      }

    case HELMET_SRP_NO_PROP_TYPE:
      {
        if (domain === 'attico') {
          switch (category) {
            case 'commerciale':
              return "Tutti gli annunci di commerciale/industriale".concat(descTr).concat(getLocalities(data.locations, domain, 'desc', withZone), ": la soluzione che stai cercando \xE8 su Attico.it!");

            case 'vacanze':
              return "Tutti gli annunci di case vacanza".concat(descTr).concat(getLocalities(data.locations, domain, 'desc', withZone), ": la soluzione che stai cercando \xE8 su Attico.it!");

            default:
              return "Tutti gli annunci di case, appartamenti ed altri immobili".concat(descTr).concat(getLocalities(data.locations, domain, 'desc', withZone), ": la soluzione che stai cercando \xE8 su Attico.it!");
          }
        } else {
          var moreInfos;
          var SEOTitleStart;

          var _sellerType2 = agentCategory === 'all' ? ' ' : getAgentForDesc(agentCategory);

          if (category === 'vacanze') {
            moreInfos = analyzeLocalities(data.locations) ? 'annunci di appartamenti e case vacanze ' : 'annunci di case vacanze ';
          } else {
            moreInfos = analyzeLocalities(data.locations) ? 'annunci di appartamenti e case ' : ' ';
          }

          switch (category) {
            case 'commerciale':
              SEOTitleStart = !areEquals ? 'annunci di immobili commerciali' : "annunci di immobili commerciali con ".concat(roomsRange.minimum, " locali");
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(SEOTitleStart).concat(descTr).concat(_sellerType2).concat(getLocalities(data.locations, domain, 'desc', withZone), " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

            case 'vacanze':
              moreInfos = !areEquals ? moreInfos : "".concat(getRoomsRange(roomsRange.minimum), " per vacanze ");
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(moreInfos).concat(descTr).concat(_sellerType2).concat(getLocalities(data.locations, domain, 'desc', withZone), " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

            default:
              moreInfos = !areEquals ? moreInfos : "".concat(getRoomsRange(roomsRange.minimum), " ");
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(moreInfos).concat(descTr).concat(_sellerType2).concat(getLocalities(data.locations, domain, 'desc', withZone), " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
          }
        }
      }

    case HELMET_SRP_NO_PROP_NO_LOC_TYPE:
      {
        if (domain === 'attico') {
          switch (category) {
            case 'commerciale':
              return "Tutti gli annunci di commerciale/industriale".concat(descTr, ": la soluzione che stai cercando \xE8 su Attico.it!");

            case 'vacanze':
              return "Tutti gli annunci di case vacanza".concat(descTr, ": la soluzione che stai cercando \xE8 su Attico.it!");

            default:
              return "Tutti gli annunci di case, appartamenti ed altri immobili".concat(descTr, ": la soluzione che stai cercando \xE8 su Attico.it!");
          }
        } else {
          var _SEOTitleStart3;

          var _sellerType3 = agentCategory === 'all' ? ' ' : getAgentForDesc(agentCategory);

          switch (category) {
            case 'commerciale':
              _SEOTitleStart3 = !areEquals ? 'annunci di immobili commerciali' : "annunci di immobili commerciali con ".concat(roomsRange.minimum, " locali");
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(_SEOTitleStart3).concat(_sellerType3).concat(descTr, " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

            case 'vacanze':
              _SEOTitleStart3 = !areEquals ? 'annunci di case vacanze' : "".concat(getRoomsRange(roomsRange.minimum), " per vacanze");
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(_SEOTitleStart3).concat(_sellerType3).concat(descTr, " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');

            default:
              _SEOTitleStart3 = !areEquals ? 'annunci' : getRoomsRange(roomsRange.minimum);
              return "Cerca tra ".concat(getTotalListings(count), " ").concat(_SEOTitleStart3).concat(_sellerType3).concat(descTr, " e trova l'immobile pi\xF9 adatto alle tue esigenze. Scopri di pi\xF9 su Casa.it!").concat(data.page > 1 ? " - pagina ".concat(data.page, " ") : '');
          }
        }
      }
  }
};

var createAtticoMainTitle = function createAtticoMainTitle(domain, helmetType, data) {
  var agencyDetail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var withZone = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var descTr = data.channel ? " in ".concat(data.channel) : '';

  switch (helmetType) {
    case HELMET_AGENCY_TYPE:
      return "Agenzia".concat(agencyDetail.name && agencyDetail.name !== '' ? " ".concat(agencyDetail.name) : '', ", annunci immobiliari a ").concat(agencyDetail.address.suburb);

    case HELMET_AGENCY_NOT_FOUND_TYPE:
      return 'Agenzia non trovata';

    case HELMET_SRP_TYPE:
      {
        var propertyTypes = data.filters.propertyTypes;
        return "".concat(getPropertyTypes(propertyTypes)).concat(descTr).concat(getLocalities(data.locations, domain, withZone));
      }

    case HELMET_SRP_NO_LOC_TYPE:
      {
        var _propertyTypes2 = data.filters.propertyTypes;
        return "".concat(getPropertyTypes(_propertyTypes2)).concat(descTr);
      }

    case HELMET_SRP_NO_PROP_TYPE:
      {
        var category = data.filters.category;

        switch (category) {
          case 'commerciale':
            return "Commerciale/Industriale".concat(descTr).concat(getLocalities(data.locations, domain, withZone));

          case 'vacanze':
            return "Case vacanza".concat(descTr).concat(getLocalities(data.locations, domain, withZone));

          default:
            return "Immobili".concat(descTr).concat(getLocalities(data.locations, domain, withZone));
        }
      }

    case HELMET_SRP_NO_PROP_NO_LOC_TYPE:
      {
        var _category4 = data.filters.category;

        switch (_category4) {
          case 'commerciale':
            return "Commerciale/Industriale".concat(descTr);

          case 'vacanze':
            return "Case vacanza".concat(descTr);

          default:
            return "Immobili".concat(descTr);
        }
      }
  }
};

var getHelmetType = function getHelmetType(data, agencyDetail, type) {
  var propertyTypes = Array.isArray(data.filters.propertyTypes) ? data.filters.propertyTypes : [data.filters.propertyTypes];

  if (type === HELMET_TYPE_H1 && propertyTypes.length > 1) {
    data.filters.propertyTypes = 'all';
  }

  if ('agencyIds' in data.filters && data.filters.agencyIds) {
    // AGENCY DETAIL LISTING
    if (agencyDetail && Object.keys(agencyDetail).length) {
      return HELMET_AGENCY_TYPE;
    }

    return HELMET_AGENCY_NOT_FOUND_TYPE;
  }

  if (data.filters.propertyTypes === 'all' || data.filters.propertyTypes === 'All' || data.filters.propertyTypes.length === 0) {
    if (data.locations.length || data.geo && data.geo.l9) {
      return HELMET_SRP_NO_PROP_TYPE;
    }

    return HELMET_SRP_NO_PROP_NO_LOC_TYPE;
  }

  if (data.locations.length || data.geo && data.geo.l9) {
    return HELMET_SRP_TYPE;
  }

  return HELMET_SRP_NO_LOC_TYPE;
};

function createHelmet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      domain = _ref.domain,
      lang = _ref.lang,
      seodata = _ref.seodata,
      locations = _ref.locations,
      _ref$agencyDetail = _ref.agencyDetail,
      agencyDetail = _ref$agencyDetail === void 0 ? {} : _ref$agencyDetail,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count;

  var data = {
    channel: TR_ENCODED[lang][seodata.tr || seodata.queryObject.tr || 'vendita'] || 'vendita',
    page: seodata.page || seodata.queryObject.page || 1,
    locations: locations,
    filters: {
      agentCategory: seodata.sellerType || 'all',
      category: seodata.propertyTypeGroup || seodata.queryObject.propertyTypeGroup || seodata.category || seodata.queryObject.category,
      features: {
        interiorFeatures: [],
        exteriorFeatures: []
      },
      landSize: {
        minimum: seodata.mqMin || seodata.queryObject.mqMin || 'any',
        maximum: seodata.mqMax || seodata.queryObject.mqMax || 'any'
      },
      minimumBathroom: seodata.numBaths || 'any',
      minimumCars: seodata.numParkingSpaces || 'any',
      onlyWithPhoto: seodata.queryObject.photo || false,
      priceRange: {
        minimum: seodata.priceMin || seodata.queryObject.priceMin || 'any',
        maximum: seodata.priceMax || seodata.queryObject.priceMax || 'any'
      },
      propertyTypes: seodata.propertyTypes || [],
      roomsRange: {
        minimum: seodata.queryObject.numRoomsMin || 'any',
        maximum: seodata.queryObject.numRoomsMax || 'any'
      },
      surroundingSuburbs: seodata.queryObject.surrounding || seodata.queryObject.includeSurrounding || false,
      availability: seodata.availability,
      balcony: seodata.balcony,
      buildingCondition: seodata.buildingCondition,
      buildingYearRange: {
        min: seodata.buildingYearMin || seodata.queryObject.buildingYearMin || 'any',
        max: seodata.buildingYearMax || seodata.queryObject.buildingYearMax || 'any'
      },
      energyClass: seodata.energyClass,
      garden: seodata.garden,
      heatingType: seodata.heatingType,
      level: seodata.level,
      lift: seodata.lift,
      photo: seodata.photo,
      terrace: seodata.terrace,
      agencyIds: seodata.publisherId
    }
  };
  var helmetType = getHelmetType(data, agencyDetail);
  var title = createTitle(domain, helmetType, data, agencyDetail, true);
  var helmetTypeH1 = getHelmetType(data, agencyDetail, HELMET_TYPE_H1);
  var h1 = createTitle(domain, helmetType, data, agencyDetail, false);
  h1 = h1.replace(/\- Casa.it/gi, '').trim();
  var h2 = title.replace(h1, "");
  h2 = h2.replace(/\- Casa.it/gi, '').trim();
  var description = createDescription(domain, helmetType, data, agencyDetail, count, true);
  var result = Object.assign({}, {
    title: title,
    description: description,
    h1: h1,
    h2: h2,
    robots: count === 0 ? 'noindex,follow' : 'index, follow',
    meta: {
      description: {
        name: 'description',
        content: description
      },
      robots: {
        name: 'robots',
        content: count > 0 && parseInt(data.page, 10) === 1 ? 'index, follow' : 'noindex,follow'
      },
      itemprop: [{
        type: 'name',
        content: title
      }, {
        type: 'description',
        content: description
      }, {
        type: 'h1',
        content: domain === 'casa.it' ? title.replace('- Casa.it', '').trim() : h1
      }]
    },
    mainTitle: createAtticoMainTitle(domain, helmetType, data, agencyDetail)
  });
  return result;
}